import type { EnrichedProposedAction } from '@/features/proposed-actions-plan';

export type GroupedActionsByRequest = ReadonlyMap<string, EnrichedProposedAction[]>;

export function groupActionsByRequest(
  actions: ReadonlyArray<EnrichedProposedAction>
): GroupedActionsByRequest {
  const grouped = new Map<string, EnrichedProposedAction[]>();
  for (const item of actions) {
    const { link } = item.action;
    if (link.type !== 'request') {
      continue;
    }
    const bucket = grouped.get(link.id);
    if (bucket) {
      bucket.push(item);
    } else {
      grouped.set(link.id, [item]);
    }
  }
  return grouped;
}
